module.exports = __webpack_public_path__ + "static/recruiter-159ae1c5050fd05506c546d33f093846.svg";